<app-preview-graph [data]="(module ? moduleMeasures$ : homeMeasures$) | async"
  color="var(--blue)"
  [measureType]="measureType">
</app-preview-graph>